// utils/constants.ts
import { SERVICE_COLORS } from '../../../Helpers/chartColors';

// Re-export SERVICE_COLORS for backwards compatibility
export { SERVICE_COLORS };

export const MONTH_NAMES = [
    'Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun',
    'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'
];